import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route , Link , Switch} from 'react-router-dom'
import * as serviceWorker from './serviceWorker';
import 'antd-mobile/dist/antd-mobile.min.css';
function asyncComponent(importComponent) {
  class AsyncComponent extends Component {
    constructor(props) {
      super(props);
      this.state = {
        component: null
      };
    }

    async componentDidMount() {
      const { default: component } = await importComponent();

      this.setState({
        component: component
      });
    }

    render() {
      const C = this.state.component;
      return C ? < C {...this.props} /> : null;
    }
  }
  return AsyncComponent;
}

const Home=asyncComponent(()=>import('./page/home/index.js'));//首页
const SearchHouse=asyncComponent(()=>import('./page/searchHouse/index.js'));//搜索框跳转
const SellHouseList=asyncComponent(()=>import('./page/sellHouseList/index.js'));//二手房列表页
const HouseDetail=asyncComponent(()=>import('./page/houseDetail/index.js'));//二手房详情以及租房详情页  共用一个页面
const RentHouseList=asyncComponent(()=>import('./page/rentHouseList/index.js'));//租房列表页
const NewHouseList=asyncComponent(()=>import('./page/newHouseList/index.js'));//新房列表页
const NewHouseDetail=asyncComponent(()=>import('./page/newhousedetail/index.js'));//新房详情页
const NewHouseInfo=asyncComponent(()=>import('./page/newhousedetail/more/newhouseinfo.js'));//新房详情页更多楼盘信息
const UnitsList=asyncComponent(()=>import('./page/newhousedetail/more/unitslist.js'));//楼盘详情户型图列表
const UnitsDetail=asyncComponent(()=>import('./page/newhousedetail/more/unitsdetail.js'));//楼盘详情户型图详情
const Video=asyncComponent(()=>import('./page/houseDetail/video.js'));//查看视频页面
const SurroundMap=asyncComponent(()=>import('./page/houseDetail/map.js'));//房源详情查看周边配套页面
const NewsList=asyncComponent(()=>import('./page/news/index.js'));//行业资讯列表页
const NewsDetail=asyncComponent(()=>import('./page/news/detail.js'));//行业资讯详情页
const EstateList=asyncComponent(()=>import('./page/estateList/index.js'));//小区列表
const SearchEstate=asyncComponent(()=>import('./page/searchEstate/index.js'));//小区模糊查询
const EstateDetail=asyncComponent(()=>import('./page/estateDetail/index.js'));//小区详情
const EstateSurroundMap=asyncComponent(()=>import('./page/estateDetail/map.js'));//小区详情查看周边配套页面
const MapHouse=asyncComponent(()=>import('./page/mapHouse/index.js'));//地图找房
const Trust = asyncComponent(()=>import("./page/trust/index")) ;//在线委托
const Trustmf = asyncComponent(()=>import("./page/trust/trustmf")); //在线委托-买房
const Trustzf = asyncComponent(()=>import("./page/trust/trustzf")) ;//在线委托-卖房
const Trustcs = asyncComponent(()=>import("./page/trust/trustcs")); //在线委托-出售
const Trustcz = asyncComponent(()=>import("./page/trust/trustcz")); //在线委托-出租
const Brokerlist = asyncComponent(()=>import("./page/brokerlist/index"));//加载经纪人列表
const Brokerdetail = asyncComponent(()=>import("./page/brokerdetail/index"));//加载经纪人详情
const EmplyidenCard = asyncComponent(()=>import('./page/emplyidencard/index.js')) //经纪人微名片
const Storelist = asyncComponent(()=>import('./page/storelist/index'));//加载门店列表
const PerformanceSearch = asyncComponent(()=>import('./page/performance/index'));//加载履约服务查询
const PerformanceList = asyncComponent(()=>import('./page/performance/list'));//加载履约服务合同列表
const PerformanceDetail = asyncComponent(()=>import('./page/performance/detail'));//加载履约服务合同详情
const PersonalInfo = asyncComponent(()=>import('./page/personal/index'));//加载个人中心
const Calculator = asyncComponent(()=>import('./page/calculator/index'));//计算器
const AboutUs = asyncComponent(()=>import('./page/personal/aboutus'));//加载公司简介
const ConcernList=asyncComponent(()=>import('./page/personal/concernlist'));//加载我的关注
const HistoryList=asyncComponent(()=>import('./page/personal/historyred'));//加载我的浏览记录
const EmplyIden=asyncComponent(()=>import('./page/emplyiden/index.js'));//员工认证
const EmplyeeSale=asyncComponent(()=>import('./page/emplyiden/emplyeeSale.js')) //销售业绩
const StoresManage=asyncComponent(()=>import('./page/emplyiden/storesManaging.js')) //微店管理
const ShareList=asyncComponent(()=>import('./page/emplyiden/sharelist.js')) //我的分享
const ErrorPage=asyncComponent(()=>import('./page/error/index.js'));//出错页面
const Chat=asyncComponent(()=>import('./page/chat/index.js'));//微聊
const ChatList=asyncComponent(()=>import('./page/chatList/index.js'));//微聊列表
const PhoneLogin=asyncComponent(()=>import('./page/phoneLogin/index.js'));//电话注册
ReactDOM.render((
    <BrowserRouter>
        <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/searchHouse" component={SearchHouse} />
            <Route path="/sellHouseList" component={SellHouseList} />
            <Route path="/rentHouseList" component={RentHouseList} />
            <Route path="/newHouseList" component={NewHouseList} />
            <Route path="/newhousedetail" component={NewHouseDetail} />
            <Route path='/newhouseinfo' component={NewHouseInfo}/>
            <Route path='/unitslist' component={UnitsList}/>
            <Route path='/unitsdetail' component={UnitsDetail}/>
            <Route path="/houseDetail" component={HouseDetail} />
						<Route path="/surroundMap" component={SurroundMap} />
						<Route path="/estateDetail" component={EstateDetail} />
						<Route path="/estateSurroundMap" component={EstateSurroundMap} />
						<Route path="/mapHouse" component={MapHouse} />
            <Route path="/video" component={Video} />
            <Route path="/newsList" component={NewsList} />
            <Route path="/newsDetail" component={NewsDetail} />
            <Route path='/trust' component={Trust}/> 
            <Route path='/trustmf' component={Trustmf}/> 
            <Route path='/trustzf' component={Trustzf}/>  
            <Route path='/trustcs' component={Trustcs}/> 
            <Route path='/trustcz' component={Trustcz}/>
            <Route path='/brokerlist' component={Brokerlist}/>
            <Route path='/brokerdetail' component={Brokerdetail}/>
            <Route path='/emplyidencard' component={EmplyidenCard}/>
            <Route path='/storelist' component={Storelist}/>
            <Route path='/personal' component={PersonalInfo}/>
            <Route path="/searchEstate" component={SearchEstate} />
            <Route path="/estateList" component={EstateList} />
            <Route path="/aboutus" component={AboutUs} />
            <Route path="/concern" component={ConcernList}/>
            <Route path="/histry" component={HistoryList}/>
            <Route path="/performance" component={PerformanceSearch}/>
            <Route path="/performancelist" component={PerformanceList}/>
            <Route path="/performancedetail" component={PerformanceDetail}/>
            <Route path="/calculator" component={Calculator} />
            <Route path="/emplyiden" component={EmplyIden}/>
            <Route path='/emplyeesale' component={EmplyeeSale}/>
            <Route path='/storesmanaging' component={StoresManage}/>
            <Route path='/sharelist' component={ShareList}/>
            <Route path='/chat' component={Chat}/>
            <Route path='/chatList' component={ChatList}/>
            <Route path='/phonelogin' component={PhoneLogin}/>
            <Route component={ErrorPage} />
        </Switch>
    </BrowserRouter>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
